<template>
  <div class="main">
    <el-form
      id="formLogin"
      ref="formLogin"
      class="user-layout-login"
      :model="form"
    >
      <el-form-item v-if="!notShowMarketSelect">
        <el-select
          v-model="marketId"
          placeholder="请选择市场"
          style="width:100%;"
          @change="selectMarketChange"
        >
          <el-option
            v-for="item in marketList"
            :key="item.key"
            :label="item.val"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
      <template v-if="!isMT">
        <el-form-item>
          <el-input
            v-model.trim="form.username"
            placeholder="帐号"
          />
        </el-form-item>
      </template>

      <template v-if="isMT">
        <el-form-item label="登录类型">
          <el-radio-group
            v-for="item in mtLoginTypeList"
            :key="item.id"
            v-model="form.loginType"
            @change="selectLoginTypeChange"
          >
            <el-radio
              class="m-l-20 m-r-20"
              :label="item.id"
            >
              {{ item.name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="form.account"
            placeholder="账号"
            @blur="searchAccount(form.account)"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="form.username"
            style="width:100%;"
            placeholder="请选择子账号"
          >
            <el-option
              v-for="(item, index) in accountList"
              :key="index"
              :label="item.alias"
              :value="item.account"
            />
          </el-select>
        </el-form-item>
      </template>

      <el-form-item>
        <el-input
          v-model.trim="form.password"
          type="password"
          :placeholder="form.loginType==='fund'? '支付密码' :'登录密码'"
        />
      </el-form-item>
      <el-form-item v-if="!isMT">
        <!-- <el-checkbox v-model="rememberMe">记住密码</el-checkbox> -->
        <router-link
          to="/forget-password"
          class="forge-password"
          style="float: right;"
        >
          忘记密码
        </router-link>
      </el-form-item>
      <el-form-item style="margin-top:24px">
        <el-button
          type="primary"
          class="login-button"
          @click="handleSubmit"
        >
          确定
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import api from '@/api'
export default {
  data () {
    return {
      rememberMe: false,
      isMT: false, // 是否是白糖市场下的会员
      form: {
        username: '',
        password: '',
        account: '',
        loginType: 'purchase',
      },
      marketList: [],
      // 沐甜登录类型
      mtLoginTypeList: [
        { id: 'purchase', name: '购销查询' },
        { id: 'fund', name: '资金管理' },
      ],
      account: '',
      accountList: [],
      marketId: '',
      mtLoginRules: [
        { name: 'loginType', message: '请选择登录类型' },
        { name: 'account', message: '请输入账号' },
        { name: 'username', message: '请选择子账号' },
        { name: 'password', message: '请输入登录/支付密码' },
      ],
      loginRules: [
        { name: 'username', message: '请输入账号' },
        { name: 'password', message: '请输入登录密码' },
      ],
      notShowMarketSelect: false, // 控制是否展示市场选择框
    }
  },
  computed: {
    redirect () {
      return '/home'
    },
    ...mapState({
      marketCodes: state => state.user.marketCodes || []
    })
  },
  watch: {
    '$route.query.marketId' (val) {
      if (val === '000') {
        // 路由含有marketId白糖市场的话不展示市场选择框
        this.isMT = true
        this.notShowMarketSelect = true
        this.marketId = val
      } else {
        this.isMT = this.marketCodes.includes('000')
        this.notShowMarketSelect = false
        this.getMarket()
      }
    }
  },
  created () {
    this.marketId = this.$route.query.marketId
    const mtMarket = this.$route.query.marketId === '000'
    this.isMT = mtMarket
    this.notShowMarketSelect = mtMarket
    !this.notShowMarketSelect && this.getMarket()
  },
  mounted () {
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    // 获取市场
    getMarket () {
      api.common.getSelectData('market_code_name').then(res => {
        this.marketList = res.data
        // 默认为上次登录的市场 每个用户只有一个市场
        this.marketId = this.marketCodes.length ? this.marketCodes[0] : ''
        this.isMT = this.marketId === '000'
      })
    },
    // 重置账号密码
    resetForm (loginType = '') {
      this.form = {
        username: '',
        password: '',
        account: '',
        loginType: loginType
      }
      this.accountList = []
    },
    selectMarketChange (val) {
      this.resetForm('purchase')
      this.notShowMarketSelect = false
      // 是否是沐甜
      this.isMT = val === '000'
    },
    selectLoginTypeChange (val) {
      // 重置账号密码
      this.resetForm(val)
    },
    // 主账号输入框失焦，搜索子账号
    searchAccount (account) {
      if (!account) return
      let param = {
        account: account,
        accountType: this.form.loginType === 'fund' ? 'FINANCIAL' : 'VIEW',
      }
      api.user.childAccount(param).then(res => {
        if (!res.data || res.data.length === 0) {
          this.$message({
            message: '当前账号下没有相关子账号',
            type: 'warning'
          })
        }
        this.accountList = res.data
        this.$nextTick(() => {
          this.form.username = res.data.length === 1 ? res.data[0].account : '' // 子账号只有一个，默认选中，多个或没有，清空，手动选择
        })
      })
    },
    // 登录
    async handleSubmit (e) {
      e.preventDefault()
      let accountType = ''
      if (this.loginType === 'fund') {
        accountType = 'FINANCIAL'
      }
      if (this.$utils.checkEmptyRules(this.form, this.marketId === '000' ? this.mtLoginRules : this.loginRules)) {
        return
      }
      try {
        await this.Login({
          username: this.form.username,
          password: this.form.password,
          marketId: this.marketId,
          accountType
        })
        this.loginSuccess()
      } catch (e) {
        console.log(e)
      }
    },
    loginSuccess (res) {
      this.$router.push({ path: `${this.redirect}` })
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notify.success({
          title: '欢迎',
          message: `${this.$store.state.user.name}，欢迎回来`
        })
      }, 1000)
    },
  }
}
</script>

<style lang="scss" scoped>
.user-layout-login {
  label {
    font-size: 14px;
  }

  .forge-password {
    font-size: 14px;
    margin: -15px auto;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }
}
</style>
